import React from 'react';
import { Box, Divider, Grid, Skeleton } from '@mui/material';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { hexWithOpacity } from 'common/utils';

interface Props {
    count?: number;
}

export default function SectionSkeleton({ count = 1 }: Props) {
    const globalStyles = useGlobalStyles();


    return (
        <Box className={globalStyles.sectionContainer}>
            {/* Header */}
            <Box className={globalStyles.sectionHeader}>
                <Skeleton
                    variant="text"
                    width={180}
                    height={28}
                    sx={{ bgcolor: colors.skeleton }}
                />
            </Box>

            <Divider />

            <Grid container p={3} spacing={1.5}>
                {Array.from({ length: count }).map((_, index) => (
                    <React.Fragment key={index}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Box>
                                {/* Label */}
                                <Skeleton
                                    variant="text"
                                    width="40%"
                                    height={18}
                                    sx={{ mb: 0.5, bgcolor: colors.skeleton }}
                                />

                                {/* Value */}
                                <Skeleton
                                    variant="text"
                                    width="75%"
                                    height={22}
                                    sx={{ bgcolor: colors.skeleton }}
                                />
                            </Box>
                        </Grid>

                        {/* Divider after every 2 items, except last pair */}
                        {index % 2 === 1 && index < count - 1 && (
                            <Grid size={12}>
                                <Divider />
                            </Grid>
                        )}
                    </React.Fragment>
                ))}
            </Grid>
        </Box>
    );
}
